import {companyFeaturesConstants} from '../../constants';
import {useCompanyFeatureAvailable} from './useCompanyFeatureAvailable';

const featureName = companyFeaturesConstants.BULK_PAYMENTS_AVAILABLE;

/**
 * Checks if bulk invoice payments are switched on for the company.
 *
 * @returns {boolean} True when the `bulk_payments_available` company feature is enabled.
 *
 * @example
 * const isBulkPaymentsAvailable = useIsBulkPaymentsAvailable();
 */
export const useIsBulkPaymentsAvailable = () => {
  return useCompanyFeatureAvailable(featureName);
};
